/**
 * @module client-api-base
 * @module_directory /modules/client/base
 * @module_path pages/kpisapproval
 * @description KPI value approval
 *
 * @section 4.1.9.2
 *
 */
import React from "react";
import { makeThemedStyles } from "./../../viewcomponents/utils";
import { useAppContext } from "./../../context/AppCtxProvider";
import { t } from "i18next";
const useStyles = makeThemedStyles("", (theme) => ({
  descriptionBox: {
    alignItems: "center",
    padding: "1.02em 1.48em",
    border: "0.11em solid rgb(209, 213, 219)",
    borderRadius: "0.68em",
    margin: "0 2.85em 3.65em 2.74em",
  },
  descriptionHeader: {
    height: "1.25em",
    fontFamily: "Dubai",
    fontStyle: "normal",
    fontWeight: 500,
    fontSize: "1.82em",
    lineHeight: "1.25em",
    color: "rgb(76, 81, 87)",
  },
  descriptionBody: {
    height: "4.28em",
    fontFamily: "Dubai",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: "1.6em",
    lineHeight: "1.42em",
    color: "rgb(76, 81, 87)",
  },
}));
const FormulaBox = (props: { description: string }) => {
  const { description } = props;
  const classes = useStyles();
  const { rtl } = useAppContext();
  const title = rtl
    ? `${t("Formula Description")} ${t("KPI")}`
    : `${t("KPI")} ${t("Formula Description")}`;
  return (
    <div className={classes.descriptionBox}>
      <div className={classes.descriptionHeader}>{title}</div>
      <div className={classes.descriptionBody}>{description}</div>
    </div>
  );
};
export default FormulaBox;
